exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".invoice-title h2, .invoice-title h3 {\n  display: inline-block; }\n\n.table > tbody > tr > .no-line {\n  border-top: none; }\n\n.table > thead > tr > .no-line {\n  border-bottom: none; }\n\n.table > tbody > tr > .thick-line {\n  border-top: 2px solid; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/order/order-details.component.scss
// module id = 44
// module chunks = 0 1